import React, { useState } from 'react'
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material'

/**
 * #380 §2.3 "VIEW → EDIT" — the actor's own confirmation, never a second
 * approver (decision 21). "The confirm dialog repeats the target and the
 * forbidden list" — so this dialog is not a generic reason prompt, it names
 * the employer being edited and reminds the actor what EDIT still can't do.
 */
export default function ElevateDialog({ open, onClose, onConfirm, employerLabel, submitting, errorMessage }) {
  const [reason, setReason] = useState('')
  const [confirmed, setConfirmed] = useState(false)

  const handleClose = () => {
    if (submitting) return
    setReason('')
    setConfirmed(false)
    onClose()
  }

  const canSubmit = reason.trim().length > 0 && confirmed && !submitting

  return (
    <Dialog open={open} onClose={handleClose} dir="rtl" fullWidth maxWidth="sm">
      <DialogTitle>מעבר לעריכה בכניסת תמיכה</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {employerLabel ? `אתה עומד לעבור למצב עריכה עבור ${employerLabel}.` : 'אתה עומד לעבור למצב עריכה.'}
          {' '}הפעולה תתועד עם שמך האמיתי, לצד המעסיק/המשתמש שבהקשר.
        </DialogContentText>
        <DialogContentText sx={{ mb: 2 }}>
          גם במצב עריכה, אין אפשרות לאשר או לפתוח מחדש חודש שכר, לייצא שכר, לבצע
          שינוי כספי/תמחור/חיוב, שינוי הרשאות, או פעולות זהות/שחזור/חסימה — פעולות
          אלה דורשות יציאה מכניסת התמיכה.
        </DialogContentText>
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={2}
          label="סיבה לעריכה"
          value={reason}
          onChange={(event) => setReason(event.target.value)}
          disabled={submitting}
          sx={{ mb: 1 }}
        />
        <FormControlLabel
          control={(
            <Checkbox
              checked={confirmed}
              onChange={(event) => setConfirmed(event.target.checked)}
              disabled={submitting}
            />
          )}
          label="אני מאשר/ת שאני עורך/ת בפועל, תחת זהותי האמיתית"
        />
        {errorMessage && (
          <Box sx={{ mt: 1 }}>
            <Typography color="error">{errorMessage}</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>ביטול</Button>
        <Button
          variant="contained"
          disabled={!canSubmit}
          onClick={() => onConfirm({ reason: reason.trim(), confirm: true })}
        >
          מעבר לעריכה
        </Button>
      </DialogActions>
    </Dialog>
  )
}
